import { Descendant, Element } from "slate";

import { makeNodeId } from "components/slate/config/makeNodeId";
import { LinkType, LinkElement } from "./types";

export const createLinkElement = ({
  url,
  text,
  children = [],
}: {
  url: string;
  text?: string;
  children?: Descendant[];
}): LinkElement => {
  if (text) {
    children = [{ text }];
  }

  return { id: makeNodeId(false), type: LinkType, url, children };
};

export const isLinkElement = (value: any): value is LinkElement => {
  return Element.isElementType<LinkElement>(value, LinkType);
};
